/*global AddressFinder*/

// https://addressfinder.nz/
class AddressAutocomplete {
  constructor() {
    this.widgets = []
    this.addressFields = [...document.querySelectorAll("[js-postal-address]")]

    if (this.addressFields.length) {
      this.downloadAddressFinder()
    }
  }

  downloadAddressFinder() {
    var script = document.createElement("script")
    script.src = "https://api.addressfinder.io/assets/v3/widget.js"
    script.async = true
    script.onload = this.initAddressFinder.bind(this)
    document.body.appendChild(script)
  }

  initAddressFinder() {
    this.addressFields.forEach(addressField => {
      const widget = new AddressFinder.Widget(addressField, window.AddressFinderKey, "NZ", {
        address_params: {},
        manual_style: true,
        byline: false,
      })

      const namePrefix = addressField.getAttribute("js-postal-address")

      // eslint-disable-next-line no-unused-vars
      widget.on("address:select", function(fullAddress, metaData) {
        addressField.value = fullAddress
        document.querySelector(`[name="${namePrefix}[Address1]"]`).value = metaData.address_line_1

        // address line 2 is sometimes undefined
        if (metaData.address_line_2 !== undefined) {
          document.querySelector(`[name="${namePrefix}[Address2]"]`).value = metaData.address_line_2
        } else {
          document.querySelector(`[name="${namePrefix}[Address2]"]`).value = null
        }

        document.querySelector(`[name="${namePrefix}[Suburb]"]`).value = metaData.suburb
        document.querySelector(`[name="${namePrefix}[City]"]`).value = metaData.city
        document.querySelector(`[name="${namePrefix}[Postcode]"]`).value = metaData.postcode
        document.querySelector(`[name="${namePrefix}[Country]"]`).value = "New Zealand"
        document.querySelector(`[name="${namePrefix}[dpid]"]`).value = metaData.dpid !== undefined ? metaData.dpid : ""

        document.querySelector('[name="StreetNumber"]').value = metaData.number + (metaData.alpha || "")
        document.querySelector('[name="StreetName"]').value = metaData.street
        document.querySelector('[name="Suburb"]').value = metaData.suburb
        document.querySelector('[name="City"]').value = metaData.city
        document.querySelector('[name="Region"]').value = metaData.region
        document.querySelector('[name="Postcode"]').value = metaData.postcode
        document.querySelector('[name="Country"]').value = "New Zealand"
      })

      this.widgets.push(widget)
    })
  }
}

export default AddressAutocomplete
